import { Component } from '@angular/core';
import { ClientsService } from '../../../core/services/clients/clients.service';
import { ClientsTableComponent } from '../../../components/clients-table/clients-table.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PaginationComponent } from '../../../components/pagination/pagination.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule, DatePipe } from '@angular/common';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { CLIENT_RELATION_TYPES, CLIENT_TYPES, RELATED_PERSON_TYPES } from '../../../core/constants/client.constants';
import { FiltersService } from '../../../core/services/declarations/filters.service';
import { faUserPlus, faCalendarClock } from '@fortawesome/pro-solid-svg-icons';
import { ClientState } from '../../../core/enums/client-state.enum';
import { PermissionService } from '../../../core/services/permission.service';
import { Permission } from '../../../core/enums/permission.enum';

@Component({
  selector: 'app-clients-list',
  standalone: true,
  imports: [
    ClientsTableComponent, 
    FontAwesomeModule, 
    PaginationComponent, 
    ProgressSpinnerModule, 
    CommonModule, 
    MultiSelectModule, 
    DropdownModule,
    FormsModule,
    DatePipe,
  ],
  templateUrl: './clients-list.component.html',
  styleUrl: './clients-list.component.scss'
})
export class ClientsListComponent {

  faUserPlus = faUserPlus;
  faCalendarClock = faCalendarClock;

  tabs = [
    {
      name: 'Clientes',
      key: 'clients'
    },
    {
      name: 'Pendientes de alta',
      key: 'pending'
    }
  ]

  activeTab = 'clients';

  headers = [ 
    {
      name: 'Código Cliente',
      key: 'code'
    },
    {
      name: 'Grupo Cliente',
      key: 'codeApplication'
    },
    {
      name: 'Cliente',
      key: 'name'
    },
    // {
    //   name: 'Area',
    //   key: 'area'
    // },
    // {
    //   name: 'Responsable interno',
    //   key: 'responsible'
    // },
    {
      name: 'Tipo de cliente',
      key: 'clientType'
    },
    // {
    //   name: 'Facturación',
    //   key: 'billing'
    // },
    {
      name: 'Estado',
      key: 'state'
    },
    // {
    //   name: 'Fecha de baja',
    //   key: 'endDate'
    // }
  ];

    configTable = {
      headers: this.headers,
      data: undefined,
      isClients: true,
    }

    currentPage = 0;
    itemsForPage = 10;
    maxPages = undefined;
    pendingCount = 0;
    isLoading: boolean;

    selectedClients = undefined;
    selectedPersonType = undefined;
    selectedClientCodes = undefined;
    selectedResponsible = undefined;

    isCreationModalVisible = false;
    isExpirationsModalVisible = false;
    expirations: any[] = [];
    isLoadingExpirations = false;

    personTypes = CLIENT_TYPES;
    selectedCreationPersonType = 'PHYSICAL_PERSON';

    relationTypes = CLIENT_RELATION_TYPES;
    selectedCreationRelationType = undefined;

    responsables = [];
    clients = [];
    clientCodes = [];
    hasEditPermission = false;
    constructor (
      private clientsService: ClientsService,
      private filtersService: FiltersService,
      private router: Router,
      private route: ActivatedRoute,
      private permissionService: PermissionService
    ) { }

    async ngOnInit() { 
      this.isLoading = true;
      this.hasEditPermission = this.permissionService.hasPermission(Permission.ManageClients);
      const qp = this.route.snapshot.queryParams;
      if(qp) {
        this.activeTab = qp['tab'] || this.activeTab;
        this.currentPage = qp['page'] ? Number(qp['page']) : this.currentPage;
        this.selectedClients = qp['clientId'] ? Number(qp['clientId']) : undefined;
        this.selectedClientCodes = qp['clientCode'] ? Number(qp['clientCode']) : undefined; // las opciones son numéricas
        this.selectedPersonType = qp['personType'] || undefined;
        this.selectedResponsible = qp['responsible'] ? qp['responsible'].split(',').map(v => Number(v)) : undefined;
      }
      try {
        this.clients = await this.filtersService.getClients();
        this.clientCodes = this.clients.filter(client => client.code !== null);
        this.responsables = await this.filtersService.getUsers();
        await this.loadPage();
      } finally {
        this.isLoading = false; // un fallo de red no debe dejar el spinner para siempre
      }
    }

    async changeTab(tab) {
      this.activeTab = tab.key;
      this.currentPage = 0;
      this.updateQueryParams();
      await this.getData();

    }
    
    async loadPage() {
      await this.getData();
    }

    private lastRequestId = 0;

    async getData() {
      let data;
      const requestId = ++this.lastRequestId; // descartar respuestas viejas si el usuario cambia de filtro o página rápido

      if(this.activeTab === 'clients') {
        data = await this.clientsService.getClients(this.currentPage, this.itemsForPage, this.selectedClients, this.selectedClientCodes, this.selectedPersonType, this.selectedResponsible);
      } else {
        data = await this.clientsService.getClients(this.currentPage, this.itemsForPage, this.selectedClients, this.selectedClientCodes, this.selectedPersonType, this.selectedResponsible, ClientState.Pending);
      }
      if (requestId !== this.lastRequestId) return;
      this.maxPages = data.totalPages+1;
      this.pendingCount = data.pendingCount;
      data.clients.forEach(client => {
        //client.state = client.endDate ? 'INACTIVE' : 'ACTIVE';
        client.responsible = client.responsible ? client.responsible.name : 'No asignado';
      });
      this.configTable = {...this.configTable, headers: this.headers, data: data.clients};
      this.isLoading = false;
    }

    private updateQueryParams() {
      const queryParams: any = {
        tab: this.activeTab || null,
        page: this.currentPage ?? 0,
        clientId: this.selectedClients ?? null,
        clientCode: this.selectedClientCodes ?? null,
        personType: this.selectedPersonType ?? null,
        responsible: this.selectedResponsible && this.selectedResponsible.length ? this.selectedResponsible.join(',') : null
      };
      this.router.navigate([], { relativeTo: this.route, queryParams, queryParamsHandling: 'merge' });
    }

    createClient() {
      this.isCreationModalVisible = false;
      this.router.navigate(
        ['/clients/detail/new'],
        { queryParams: { personType: this.selectedCreationPersonType, relationType: this.selectedCreationRelationType } }
      );
    }

    openCreationModal() {
      this.isCreationModalVisible = true;

    }

    closeCreationModal() {
      this.isCreationModalVisible = false;
    }

    async onClientSelected(event) {
      this.selectedClients = event.value;
      this.applyFilters();
    }

    async onClientCleared() {
      this.selectedClients = undefined;
      this.applyFilters();
    }

    async onClientCodeSelected(event) {
      this.selectedClientCodes = event.value;
      this.applyFilters();
    }

    async onClientCodeCleared() {
      this.selectedClientCodes = undefined;
      this.applyFilters();
    }

    async onPersonTypeSelected(event) {
      this.selectedPersonType = event.value;
      this.applyFilters();
    }

    async onPersonTypeCleared() {
      this.selectedPersonType = undefined;
      this.applyFilters();
    }

    async onResponsibleSelected(event) {
      this.selectedResponsible = event.value;
      this.applyFilters();
    }

    async onResponsibleCleared() {
      this.selectedResponsible = undefined;
      this.applyFilters();
    }

    /** Un filtro nuevo vuelve a la primera página: la actual puede no existir con menos resultados. */
    private applyFilters() {
      this.currentPage = 0;
      this.updateQueryParams();
      return this.getData();
    }

    onPageChange(page: number) {
      this.currentPage = page;
      this.updateQueryParams();
      this.getData();
    }

    async openExpirationsModal() {
      this.isExpirationsModalVisible = true;
      this.isLoadingExpirations = true;
      try {
        this.expirations = await this.clientsService.getUpcomingExpirations();
      } finally {
        this.isLoadingExpirations = false;
      }
    }

    closeExpirationsModal() {
      this.isExpirationsModalVisible = false;
    }

    navigateToExpirationClient(exp: { clientId: number; clientTab?: string }) {
      this.closeExpirationsModal();
      const queryParams: Record<string, string | number | null> = {
        tab: this.activeTab || null,
        page: this.currentPage ?? 0,
        clientId: this.selectedClients ?? null,
        clientCode: this.selectedClientCodes ?? null,
        personType: this.selectedPersonType ?? null,
        responsible:
          this.selectedResponsible && this.selectedResponsible.length
            ? this.selectedResponsible.join(',')
            : null,
        clientTab: exp.clientTab || 'identification',
      };
      this.router.navigate(['/clients/detail', exp.clientId], { queryParams });
    }

}
